import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import Toggle from 'react-toggle';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import findIndex from 'lodash/findIndex';
import head from 'lodash/head';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import { DivisionLabel } from '../shared/styled-components';
import { LoadingWrapper, BaseButton, NoAccess, RowDivision } from '../../../../styles/styled';
import Loading from '../../../../components/Loading';
import { minLengthValidator, maxLengthValidator } from '../../../../helpers/validators';
import ValidatedInput from '../../../../components/inputs/validatedInput';
import { sendNotifications } from '../../../../helpers/send_notifications';
import { OrangeSubmitButton, ButtonConfirm } from '../../../../components/buttons/buttons';
import { sendMarketingEmails } from '../../../../helpers/sendMarketingEmails';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import { authManager, soundcastManager, messageManager } from '../../../../helpers/managers';
import {
  SoundcastSelectWrapper,
  SoundcastSelect,
  ActionsWrapper,
  SubsToggleLabel,
  PublishBtn,
  ListMessage,
  AnnouncementTextArea,
  Noresult,
} from './styles';
import { ALERTS } from '../../../../helpers/texts';
const { replaceSpecialTags } = require('../../../../../server/scripts/utils')();

class Announcements extends Component {
  constructor(props) {
    super(props);

    this.state = {
      soundcastId: '',
      soundcast: null,
      soundcastsManaged: [],
      allowed: false,
      message: '',
      publishedMessages: [],
      sendEmails: false,
      modal: {
        show: false,
        title: '',
        content: '',
      },
      deleteIndex: -1,
      publishing: false,
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.internalPublish = this.internalPublish.bind(this);
    this.onChangeSoundcastId = this.onChangeSoundcastId.bind(this);
    this.onDeleteMessage = this.onDeleteMessage.bind(this);
    this.modalHandler = this.modalHandler.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.fetchSoundcastManaged();
    this.checkUserStatus(this.props.userInfo);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchSoundcastManaged(nextProps);
    if (!this.state.allowed) {
      this.checkUserStatus(nextProps.userInfo);
    }
  }

  checkUserStatus(userInfo) {
    this.setState({
      allowed: canUserAccessFeature('VIEW_MESSAGES'),
    });
  }

  fetchSoundcastManaged(props = {}) {
    // get soundcast_managed
    props = (!isEmpty(props)) ? props : this.props;
    const soundcastsManaged = this.getSoundcastsManaged(props);
    if (!isEmpty(soundcastsManaged)) {
      // console.log('soundcastsManaged', soundcastsManaged);
      this.setState({
        soundcastsManaged,
      }, () => {
        // assign default soundcastId
        this.changeSoundcastId(soundcastsManaged[0].id, props);
      });
    }
  }

  getSoundcastsManaged(props = {}) {
    props = (!isEmpty(props)) ? props : this.props;
    const { userInfo } = props;
    const soundcastsManaged = [];
    if (userInfo) {
      for (let id in userInfo.soundcasts_managed) {
        let soundcast = JSON.parse(JSON.stringify(userInfo.soundcasts_managed[id]));
        if (soundcast.title) {
          soundcastsManaged.push({
            ...soundcast,
            id,
          });
        }
      }
    }

    return soundcastsManaged;
  }

  changeSoundcastId(soundcastId, props = {}) {
    props = (!isEmpty(props)) ? props : this.props;
    const soundcast = this.getSoundcastById(soundcastId);
    this.setState({
      soundcast,
      soundcastId,
    }, () => {
      // update announcement everytime the soundcast changed
      this.loadPublishedMessages(soundcastId);
    });
  }

  getSoundcastById(soundcastId) {
    const { soundcastsManaged = [] } = this.state;
    if (!isEmpty(soundcastsManaged)) {
      const soundcast = soundcastsManaged.find(soundcast => isEqual(soundcast.id, soundcastId));
      if (soundcast) {
        return soundcast;
      }
    }

    return {};
  }

  onChangeSoundcastId(e) {
    this.changeSoundcastId(e.target.value);
  }

  onDeleteMessage(message, index) {
    const { soundcastId } = this.state;
    return () => {
      this.showModal({
        content: 'Are you sure you want to delete the message?',
        confirm: {
          ok: {
            text: 'DELETE',
            onClick: () => {
              // console.log('delete', message);
              this.closeModal();
              this.setState({
                deleteIndex: index
              }, () => {
                const { announcementId } = message;
                Axios.delete(`/api/announcements/${announcementId}`)
                  .then(({ data }) => {
                    // update firebase '/messages' document
                    messageManager.save(soundcastId, { updated_at: (new Date()).getTime() });

                    // console.log(data);
                    if (isObject(data)) {
                      // remove the message from the local array
                      const { publishedMessages } = this.state;
                      const messageIndex = findIndex(publishedMessages, pmsg => isEqual(pmsg.announcementId, announcementId));
                      if (messageIndex > -1) {
                        publishedMessages.splice(messageIndex, 1);
                      }

                      // update state
                      this.setState({
                        deleteIndex: -1,
                        publishedMessages,
                      });
                    }
                  })
                  .catch(err => {
                    this.setState({
                      deleteIndex: -1,
                    }, () => {
                      this.showModal({
                        content: 'Something went wrong when removing published message.',
                      });
                    });
                  });
              });
            }
          },
          cancel: {
            text: 'CANCEL',
            onClick: this.closeModal
          }
        },
      });
    };
  }

  loadPublishedMessages(id, loading = true) {
    this.setState({
      isLoading: loading,
    }, () => {
      Axios.get('/api/announcements', {
        params: { filter: { where: { soundcastId: id } } },
      }).then(res => {
        const publishedMessages = res.data;
        this.setState({
          isLoading: false,
          publishedMessages: publishedMessages ? publishedMessages : [],
        });
      }).catch((e) => {
        console.log('Error when loading published messages', e);
        this.showModal({
          content: 'Something went wrong when loading published messages. Please try again.',
        });
      });
    });
  }

  handlePublish() {
    this.setState({
      publishing: true,
    }, this.internalPublish);
  }

  async internalPublish() {
    const { soundcastId, message, soundcast } = this.state;
    const { userInfo } = this.props;
    const announcementId = `${moment().format('x')}a`;

    const user = authManager.getCurrentUser();
    if (user && !isEmpty(message)) {
      // check if there are subscribers
      const subscribers = await soundcastManager.getSubscribedObj(soundcastId);
      soundcast.subscribed = subscribers;

      if (!isEmpty(subscribers)) {
        const creatorID = user.uid;
        Axios.post('/api/announcements', {
          content: message,
          date_created: moment().format('X'),
          creatorId: creatorID,
          publisherId: userInfo.publisherID,
          soundcastId,
          isPublished: true,
          announcementId,
        }).then(
          data => {
            this.setState({
              message: '',
              publishing: false,
            }, () => {
              // update firebase '/messages' document
              messageManager.save(soundcastId, { updated_at: Date.now() });

              // get an array of device tokens
              let registrationTokens = [];
              Object.keys(subscribers).forEach(user => {
                if (isObject(subscribers[user])) {
                  if (isString(head(subscribers[user]))) {
                    registrationTokens.push(head(subscribers[user]));
                  }
                }
              });

              // send push notification
              sendNotifications(registrationTokens, {
                data: {
                  type: 'NEW_MESSAGE',
                  announcementId,
                  soundcastId,
                },
                notification: {
                  // title: `${userInfo.firstName} ${userInfo.lastName} sent you a message`,
                  title: `${soundcast.title} sent you a message`,
                  body: message,
                  sound: 'default',
                  badge: '1',
                },
              });

              // when sending via email
              if (this.state.sendEmails) {
                const subject = replaceSpecialTags('[soundcast_title] sent you a message on [app_name]', {
                  soundcast,
                  publisher: userInfo.publisher,
                });
                this.emailListeners(soundcast, message, subject);
              }

              // and load the published messages
              this.loadPublishedMessages(soundcastId, false);

              // show message
              this.showModal({
                content: 'Your message has been successfully sent!',
              });
            });
          },
          err => {
            this.setState({
              message: '',
              publishing: false,
            }, () => {
              console.log('ERROR adding announcement: ', err);
              this.showModal({
                content: 'Something went wrong when publishing the announcement.',
              });
            });
          }
        );
      } else {
        this.setState({
          publishing: false,
        }, () => {
          this.showModal({
            content: 'Unable to send the announcement, the soundcast has no subscribers',
          });
        });
      }
    } else {
      this.showModal({
        content: 'Please enter your announcement before publishing.'
      });
    }
  }

  emailListeners(soundcast, message, subject) {
    const { userInfo } = this.props;
    const { publisher = {} } = userInfo || {};

    function sendEmailsToRecipients(recipients = '') {
      console.log(`mailing ${recipients}`);
      return sendMarketingEmails(
        recipients, // 'subscribers' or 'invitees'
        soundcast.id,
        subject,
        message,
        publisher.name,
        publisher.imageUrl,
        publisher.email,
        4385,
      );
    };

    // send notification email to subscribers
    Promise.resolve()
      .then(() => {
        if (soundcast.subscribed) return sendEmailsToRecipients('subscribers');
      })
      .catch(e => {
        console.log('Something went wrong while sending marketing emails to susbcribers');
        console.log(e);
      })
      .then(() => {
        if (soundcast.invited) return sendEmailsToRecipients('invitees');
      })
      .catch(e => {
        console.log('Something went wrong while sending marketing emails to invitees');
        console.log(e);
      });
  }

  showModal(metadata) {
    this.modalHandler({
      show: true,
      ...metadata
    })();
  }

  closeModal() {
    this.modalHandler({
      show: false,
    })();
  }

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      confirm = {},
      onClose = false,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState({
        modal: {
          ...this.state.modal,
          show,
          title,
          content,
          confirm,
          onClose: (!show) ? false : onClose
        },
      }, () => {
        if (oldClose && !show) {
          oldClose();
        }
      });
    };
  }

  renderModal() {
    const {
      show,
      title,
      content,
      confirm,
    } = this.state.modal;
    let actions = [
      <OrangeSubmitButton
        label="OK"
        onClick={this.modalHandler({ show: false })}
        styles={{ width: '50%' }}
      />
    ];

    // if confirm exist
    if (!isEmpty(confirm)) {
      const { ok = {}, cancel = {} } = confirm;
      const { text: okText = 'OK', onClick: okHandler = () => {} } = ok;
      const { text: cancelText = 'CANCEL', onClick: cancelHandler = () => {} } = cancel;
      actions = [
        <ButtonConfirm>
          <button className="cbtn" onClick={okHandler}>{okText}</button>
          <button className="cbtn cancel" onClick={cancelHandler}>{cancelText}</button>
        </ButtonConfirm>
      ];
    }

    return (
      <Dialog
        title={(
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        )}
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}
      >
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderPublishedMessages() {
    const { publishedMessages, isLoading, deleteIndex } = this.state;

    if (isLoading) {
      return (
        <ListMessage>
          <div className="msg-wrapper">
            <Loading text="Loading published messages" align="center"/>
          </div>
        </ListMessage>
      );
    }

    if (isEmpty(publishedMessages)) {
      return (
        <ListMessage>
          <div className="msg-wrapper">
            <Noresult>You haven't sent any messages for this soundcast yet.</Noresult>
          </div>
        </ListMessage>
      );
    }

    return (
      <React.Fragment>
        {publishedMessages.map((announcement, i) => {
          const likes = announcement.likesCount;
          const comments = announcement.commentsCount;
          const listMsgClass = (deleteIndex === i) ? 'fadeDelete' : '';
          return (
            <ListMessage key={i} className={listMsgClass}>
              <div className="msg-overlay">
                <div className="msg-overlay-content">
                  <Loading />
                </div>
              </div>
              <div className="msg-wrapper">
                <div className="msg-header">
                  <div className="msg-date">
                    {moment(announcement.createdAt).format('dddd, MMMM Do YYYY, h:mm a')}
                  </div>
                  <button className="del-btn" title="Delete" onClick={this.onDeleteMessage(announcement, i)}>✖</button>
                </div>
                <div className="msg-content">
                  {announcement.content.split('\n').map((txt, key) => {
                    return (
                      <React.Fragment key={key}>{txt}<br /></React.Fragment>
                    );
                  })}
                </div>
                <div className="msg-footer">{`${likes} ${
                    likes > 1 ? 'likes' : 'like'
                  } ${comments} ${comments > 1 ? 'comments' : 'comment'}`}
                </div>
              </div>
            </ListMessage>
          );
        })}
      </React.Fragment>
    );
  }

  render() {
    const { allowed, soundcastsManaged } = this.state;
    const { history } = this.props;

    if (isEmpty(soundcastsManaged)) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="90">
            <Loading text="Verifying user, please wait"/>
          </LoadingWrapper>
        </RowDivision>
      );
    }

    if (!allowed) {
      return (
        <NoAccess>
          <div className="upgrade padding-five sm-padding-ten sm-width-90 xs-width-100 bg-white">
            <div className="title-medium sm-title-medium xs-title-medium font-weight-600 margin-five-bottom">
              Upgrade to send messages
            </div>
            <div className="text-large sm-text-large line-height-26 margin-five-bottom">
              {ALERTS().VIEW_MESSAGES.NO_ACCESS}
            </div>
            <BaseButton onClick={() => history.push('/pricing')}>UPGRADE</BaseButton>
          </div>
        </NoAccess>
      );
    }

    return (
      <MuiThemeProvider>
        <React.Fragment>
          <div>
            <div className="padding-bottom-20px padding-top-20px">
              <div className="row">
                <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
                  <div className="title-medium">Messages</div>
                </div>
              </div>
            </div>
            <RowDivision className="row">
              <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                <DivisionLabel>
                  Target Soundcast
                </DivisionLabel>
                <SoundcastSelectWrapper>
                  <SoundcastSelect
                    value={this.state.soundcastId || ''}
                    onChange={this.onChangeSoundcastId}
                  >
                    {isEmpty(soundcastsManaged) && <option>Loading...</option>}
                    {soundcastsManaged.map((soundcast, i) => {
                      return (
                        <option value={soundcast.id} key={i}>
                          {soundcast.title}
                        </option>
                      );
                    })}
                  </SoundcastSelect>
                </SoundcastSelectWrapper>
              </div>
            </RowDivision>
            <RowDivision className="row">
              <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
                <DivisionLabel>
                  Message
                </DivisionLabel>
                <AnnouncementTextArea
                  disabled={this.state.publishing}
                  placeholder='Make a new announcement'
                  onChange={e => this.setState({ message: e.target.value })}
                  value={this.state.message}
                />
              </div>
              <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
                <ActionsWrapper>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Toggle
                      id="share-status"
                      aria-labelledby="share-label"
                      checked={this.state.sendEmails}
                      onChange={() => this.setState({ sendEmails: !this.state.sendEmails })}
                    />
                    <SubsToggleLabel id="share-label">
                      Email the message to subscribers and invitees
                    </SubsToggleLabel>
                  </div>
                  <PublishBtn onClick={this.handlePublish} disabled={this.state.publishing}>
                    Publish
                  </PublishBtn>
                </ActionsWrapper>
              </div>
            </RowDivision>
            <RowDivision className="row">
              <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
                <div className="title-medium">Published Messages</div>
              </div>
            </RowDivision>
            <RowDivision className="row">
              <div className="col-lg-11 col-md-12 col-sm-12 col-xs-12">
                {this.renderPublishedMessages()}
              </div>
            </RowDivision>
          </div>

          {this.renderModal()}
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

export default Announcements;
